import '@fontsource/inter/variable.css'
import 'lib/ag-grid-init'
import * as Sentry from '@sentry/react'
import { DevBadge } from 'components/dev-tools'
import { FeatureProvider } from 'components/feature-flag'
import { Fonts } from 'components/fonts'
import { StrictMode, useEffect } from 'react'
import 'react-day-picker/dist/style.css'
import { Outlet, useRouteError, useSearchParams } from 'react-router'
import { useUserStore } from 'store'
import 'styles/globals.css'
import { logger } from '../next/lib/sentry'
import { PlainErrorBoundary } from '../components/error-boundary-plain'

export default function App() {
  const [searchParams] = useSearchParams()

  // Users who signup from the OAuth flow have this param set
  // We use it to display a special banner (<OIDCBanner />) with
  // instructions on how to set up payment.
  const oidcClient = searchParams.get('oidc_client')
  const patch = useUserStore((state) => state.patch)

  useEffect(() => {
    // Saves the oidcClient to the store so we can display the banner
    if (oidcClient && patch) patch({ oidcClient })
  }, [oidcClient, patch])

  return (
    <StrictMode>
      <FeatureProvider>
        <Fonts />
        <Outlet />
      </FeatureProvider>
      <DevBadge />
    </StrictMode>
  )
}

export const Catch = () => {
  return <PlainErrorBoundary />
}
